const headers = new Headers({
  "Content-Type": "application/json",
});

export default {
  state: {
    serverList: [],
    serverStatus: 0,
    selectedServer: null,
  },
  mutations: {
    updateServers(state, servers) {
      state.serverList = servers;
    },
    updateSelected(state, server) {
      server.password = "";
      state.selectedServer = server;
    },
    updateServerStatus(state, serverStatus) {
      state.serverStatus = serverStatus;
    },
    updatePassword(state, password) {
      state.selectedServer.password = password;
    },
  },
  getters: {
    serverList(state) {
      return state.serverList;
    },
    selected(state) {
      return state.selectedServer;
    },
    serverStatus(state) {
      return state.serverStatus;
    },
    password(state) {
      return state.selectedServer != null ? state.selectedServer.password : "";
    },
  },
  actions: {
    async requestServers(context) {
      const req = new Request(`${context.getters.url}/api/v1/servers`, {
        method: "GET",
      });
      try {
        let res = await fetch(req);
        if (res.status == 200) {
          let servers = await res.json();
          context.commit("updateServers", servers);
        } else {
          let message = (await res.text());
          throw new Error(message);
        }
      } catch (error) {
        context.commit("updateMessage", {
          title: `Ошибка при получении серверов`,
          text: error.message,
          isError: true,
        });
      }
    },
    async removeServer(context, server) {
      const req = new Request(`${context.getters.url}/api/v1/servers`, {
        method: "DELETE",
        body: JSON.stringify(server),
        headers: headers,
      });
      let servers = context.getters.serverList;
      try {
        let res = await fetch(req);
        if (res.status == 200) {
          let idx = servers.findIndex((s) => server.id == s.id);
          if (idx != -1) {
            servers.splice(idx, 1);
            context.commit("updateServers", servers);
          }
        } else {
          let message = (await res.text());
          throw new Error(message);
        }
      } catch (error) {
        context.commit("updateMessage", {
          title: `Ошибка удаления сервера`,
          text: error.message,
          isError: true,
        });
      }
    },
    async mergeServer(context, server) {
      const req = new Request(`${context.getters.url}/api/v1/servers`, {
        method: server.id? "PUT" : "POST",
        body: JSON.stringify(server),
        headers: headers,
      });
      let servers = context.getters.serverList;
      try {
        let res = await fetch(req);
        if (res.status == 200) {
          let res_server = await res.json();
          let idx = servers.findIndex((s) => res_server.id == s.id);

          if (idx == -1) {
            servers.unshift(res_server);
          } else {
            servers.splice(idx, 1, res_server);
          }
          context.commit("updateServers", servers);
        } else {
          let message = (await res.text());
          throw new Error(message);
        }
      } catch (error) {
        context.commit("updateMessage", {
          title: `Ошибка ${server.id ? "создания" : "обновления"} сервера`,
          text: error.message,
          isError: true,
        });
      }
    },
    async clearServers(context) {
      context.commit("updateServers", []);
    },
    selectServer(context, server) {
      context.commit("updateSelected", server);
    },
    async checkServer(context) {
      const obj = Object.assign({}, context.getters.selected, {
        password: context.getters.password,
      });
      const init = {
        method: "POST",
        body: JSON.stringify(obj),
        headers: headers,
      };

      let s = 0;
      try {
        let res = await fetch(
          new Request(`${context.getters.url}/api/v1/servers/connect`, init)
        );
        if (res.status == 200) {
          s = 1;
          res = await fetch(
            new Request(`${context.getters.url}/api/v1/servers/rights`, init)
          );
          if (res.status == 200) {
            s = 2;
          } else if (res.status == 403) {
            throw new Error("У пользователя недостаточно прав");
          } else if (res.status == 421) {
            throw new Error("Неверные логин или пароль");
          } else {
            throw new Error(await res.text())
          }
        } else if (res.status == 504) {
          throw new Error("Не удалось подключится к выбранному серверу");
        } else {
          throw new Error("Непредвиденная ошибка при подключении");
        }
      } catch (error) {
        context.commit("updateMessage", {
          title: `Статус подключения`,
          text: `${error.message}`,
          isError: true,
        });
      } finally {
        context.commit("updateServerStatus", s);
      }
    },
    clearSelectedServer(context) {
      context.commit("updateSelected", null);
      context.commit("updateServerStatus", 0);
    },
    updatePassword(context, password) {
      if (context.getters.selected != null)
        context.commit("updatePassword", password);
    },
    resetConnection(context) {
      context.commit("updateServerStatus", 0);
    },
  },
};
